import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../customComponent/BreadCrumbs";
import { ImageBaseUrl, breadcrumbNameMap } from "../../../utils/helperData";
import { AiOutlineDownload } from "react-icons/ai";
import { FaArrowLeft, FaRegCircleDot } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router";
import { VIEW_MANAGE_PROJECT_DETAILS } from "../../../utils/RouteConstant";
import FormSection from "../../../customComponent/FormSection/FormSection";
import FormField from "../../../customComponent/FormField/FormField";
import { useDispatch, useSelector } from "react-redux";
import {
  GetNcrReportDetails,
  downloadNcrReportPdf,
  previewNcrReportPdf,
} from "../../../../redux/action/InspectionDetails/InspectionDetailsAction";
import frame_Icon from "../../../../asesst/file_image.png";
import Modal from "./PdfModal";
import { Checkbox } from "@mui/material";

const truncateString = (str) => {
  if (str?.length > 15) {
    return str.slice(0, 15) + "...";
  }
  return str;
};

export const FORM_STATUS_STYLES = {
  0: { label: "Open" },
  1: { label: "Complete" },
  2: { label: "Delete" },
  3: { label: "Issue" },
  4: { label: "Top Ready" },
  5: { label: "Ready" },
};
const DocumentCard = ({ title, fileUrl }) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = title;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow mb-2">
      <div className="flex items-center space-x-3">
        <img
          src={frame_Icon}
          alt={`${title} Document`}
          className="w-12 h-12 rounded-lg object-cover"
        />
        <p className="font-semibold">{truncateString(title || "Document")}</p>
      </div>
      <button
        onClick={handleDownload}
        className="text-[#1C3664] hover:text-blue-700 transition-colors"
        aria-label="Download document"
      >
        <AiOutlineDownload size={24} />
      </button>
    </div>
  );
};

const ViewDetailsNcrReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { inspectionDetaildata, downloadLoading, previewUrl, pdfUrl, error } =
    useSelector((state) => state.inspectionDetails);
  const projectDetails = useSelector((state) => state.project.projectDetails);
  const [previewState, setPreviewState] = useState({
    isOpen: false,
    isLoading: false,
    error: null,
  });
  console.log("preview syate", previewState);

  useEffect(() => {
    if (location.state?.data?._id) {
      dispatch(GetNcrReportDetails(location.state.data._id));
    }
  }, [dispatch, location.state?.data?._id]);

  const handleGoBack = () => {
    navigate(
      `${VIEW_MANAGE_PROJECT_DETAILS}/${inspectionDetaildata?.project?._id}`,
      {
        state: {
          selectedTab: "Inspection Details",
          selectedInspectionIndex: 6,
        },
        replace: true,
      }
    );
  };

  // const formatDate = (dateString) => {
  //   return new Date(dateString).toLocaleDateString();
  // };

  const inspectionData = [
    {
      label: "Inspection Date",
      // value: formatDate(inspectionDetaildata?.ins_date),
          value: inspectionDetaildata?.ins_date
              ? new Date(inspectionDetaildata?.ins_date).toLocaleDateString("en-US", {
                  month: "2-digit", day: "2-digit", year: "numeric",
                })
              : "-"
    },
    { label: "System", value: inspectionDetaildata?.system },
    {
      label: "Inspection Location",
      value: inspectionDetaildata?.locName?.name,
    },
    {
      label: "Mechanical Contractor",
      value: inspectionDetaildata?.mechanical_contractor,
    },
    { label: "Equipment ID", value: inspectionDetaildata?.equipment_id },
    {
      label: "Status",
      value: FORM_STATUS_STYLES[inspectionDetaildata?.form_status]?.label,
    },
  ];

  const documentSections = [
    {
      title: "Non-Conformance / Quality Issues",
      description: inspectionDetaildata?.quality_issue?.description,
      documents: inspectionDetaildata?.quality_issue?.supporting_doc || [],
    },
    {
      title: "RFI's,Clarifications and Exceptions",
      description: inspectionDetaildata?.rfi?.description,
      documents: inspectionDetaildata?.rfi?.supporting_doc || [],
    },
    {
      title: "Material Inspection",
      description: inspectionDetaildata?.material_ins?.description,
      documents: inspectionDetaildata?.material_ins?.supporting_doc || [],
    },
    {
      title: "Fabrication",
      description: inspectionDetaildata?.fabrication?.description,
      documents: inspectionDetaildata?.fabrication?.supporting_doc || [],
    },
    {
      title: "Weld Data",
      description: inspectionDetaildata?.weld_data?.description,
      documents: inspectionDetaildata?.weld_data?.supporting_doc || [],
    },
    {
      title: "Installation Verification",
      description: inspectionDetaildata?.inst_verification?.description,
      documents: inspectionDetaildata?.inst_verification?.supporting_doc || [],
    },
    {
      title: "Miscellaneous & other information",
      description: inspectionDetaildata?.other_info?.description,
      documents: inspectionDetaildata?.other_info?.supporting_doc || [],
    },
    {
      title: "QC & Personal",
      description: inspectionDetaildata?.qc_personal?.description,
      documents: inspectionDetaildata?.qc_personal?.supporting_doc || [],
    },
  ];

  const handlePreviewReport = async () => {
    setPreviewState((prev) => ({
      ...prev,
      isLoading: true,
      isOpen: true,
      error: null,
    }));
    try {
      if (inspectionDetaildata?._id) {
        const response = await dispatch(
          previewNcrReportPdf(inspectionDetaildata._id)
        );

        const previewUrl = response;
        setPreviewState((prev) => ({
          ...prev,
          isLoading: false,
          previewUrl,
        }));
      }
    } catch (error) {
      setPreviewState((prev) => ({
        ...prev,
        isLoading: false,
        error: "Failed to load preview. Please try again.",
      }));
      console.error("Preview failed:", error);
    }
  };

  useEffect(() => {
    console.log("Preview URL:", previewUrl);
  }, [previewUrl]);

  const handleClosePreview = () => {
    setPreviewState({ ...previewState, isOpen: false });
  };

  const handleDownloadReport = async () => {
    try {
      if (inspectionDetaildata?._id) {
        await dispatch(downloadNcrReportPdf(inspectionDetaildata._id));
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const htmlContent = { previewUrl };
  return (
    <div className="max-w-full mx-auto">
      <header className="mb-6">
        <h1 className="text-3xl font-bold mb-6">Project Reports</h1>
        <div className="flex justify-between items-center">
          <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
          <div className="flex gap-2 items-center">
            {projectDetails?.document && (
              <img
                src={`${ImageBaseUrl}${projectDetails.document}`}
                alt="not"
                className="preview-image w-[3.5rem] h-12 bg-cover bg-center rounded-3xl mr-2.5"
              />
            )}
            <span className="text-xl font-semibold">
              Project Name:-
              <span className="text-blue-500"> {projectDetails?.name}</span>
            </span>
          </div>
        </div>
      </header>

      <main className="bg-white shadow-lg rounded-lg p-8">
        <div className="flex items-center text-2xl font-base font-poppins mb-8 text-[#202224]">
          <div className="flex items-center text-2xl font-base font-poppins">
            <FaArrowLeft className="cursor-pointer" onClick={handleGoBack} />
            <h3
              className="text-lg p-2 font-semibold cursor-pointer"
              onClick={handleGoBack}
            >
              Go Back
            </h3>
          </div>
          <div className="flex space-x-5 ml-auto">
            <button
              onClick={handlePreviewReport}
              disabled={!inspectionDetaildata?._id || previewState.isLoading}
              className={`bg-[#1C3664] text-white text-lg px-4 py-2 rounded-lg transition-colors flex items-center gap-2 ${
                previewState.isLoading
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-blue-900"
              }`}
            >
              {previewState.isLoading ? (
                <>
                  <span className="animate-spin">⌛</span>
                  Loading...
                </>
              ) : (
                "Preview Report"
              )}
            </button>

            <button
              onClick={handleDownloadReport}
              disabled={!inspectionDetaildata?._id || downloadLoading}
              className={`bg-[#1C3664] text-white px-4 py-2 text-lg rounded-lg transition-colors flex items-center gap-2 ${
                downloadLoading
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-blue-900"
              }`}
            >
              {downloadLoading ? (
                <>
                  <span className="animate-spin">⌛</span>
                  Loading...
                </>
              ) : (
                "Download Report pdf"
              )}
            </button>
          </div>
        </div>

        <FormSection title="Inspection Data">
          {inspectionData.map((field, index) => (
            <FormField key={index} label={field.label} value={field.value} />
          ))}
        </FormSection>

        {documentSections.map((section, index) => (
          <div className="bg-white p-2 mb-6">
            <div className="flex items-center mb-4 rounded-lg border text-[#1C3664]">
              <Checkbox
                icon={<FaRegCircleDot />}
                disabled
                style={{ color: "#1C3664" }}
              />
              <h3 className="text-lg p-2 font-semibold" key={index}>
                {section.title}
              </h3>
            </div>

            <div className="grid grid-cols-6 gap-4 p-2">
              <div className="col-span-4 mb-4">
                <label className="block text-base font-medium text-[#1C3664] mb-2">
                  Description
                </label>
                <div className="text-base text-[#626262]">
                  {section.description || "NA"}
                </div>
              </div>
              <div className="col-span-2 mt-4">
                {section.documents?.map((doc, docIndex) => (
                  <DocumentCard
                    key={docIndex}
                    title={doc}
                    fileUrl={`${ImageBaseUrl}${doc}`}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </main>

      {error && <div className="text-red-500 mt-2">Error: {error}</div>}

      {previewState.isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full relative">
            <button
              onClick={handleClosePreview}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              Close
            </button>
            {previewState.isLoading ? (
              <p>Loading preview...</p>
            ) : (
              <Modal
                isOpen={previewState?.isOpen}
                onClose={handleClosePreview}
                htmlContent={htmlContent}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewDetailsNcrReport;
